import React from 'react';
import { motion } from 'framer-motion';
const MILESTONES = [{
  label: 'Avance 01',
  title: 'Objetos Territoriales Legales (OTL)',
  subtitle: 'Ordenamiento Local del Territorio',
  href: '#resultados',
  image: 'https://cdn.magicpatterns.com/uploads/b3XxDpPc3kRjBQ4H7ZEj2X/paramo.jpg'
}, {
  label: 'Avance 02',
  title: 'Catastro multipropósito en territorios colectivos',
  subtitle: 'Catastro multipropósito en territorios colectivos',
  href: '#catastro',
  image: 'https://cdn.magicpatterns.com/uploads/4uFkeuNjJAEwEbgSqJo8au/maloka.jpg'
}, {
  label: 'Avance 03',
  title: 'Acuerdos de conservación con Parques Nacionales Naturales (PNN)',
  subtitle: 'Acuerdos con Parques Nacionales Naturales',
  href: '#hito-3',
  image: 'https://cdn.magicpatterns.com/uploads/4kU1SJA6DC7TJSuGJguKjo/paramillo.jpg'
}, {
  label: 'Avance 04',
  title: 'Colombia en Mapas',
  subtitle: 'Apropiación de los productos del IGAC',
  href: '#hito-4',
  image: 'https://cdn.magicpatterns.com/uploads/dGg8r9XUtvqygxxiqrPQif/mapacol.jpg'
}, {
  label: 'Formación',
  title: 'Diplomados virtuales',
  subtitle: 'Cursos en línea para la apropiación del conocimiento territorial',
  href: '#diplomados',
  image: 'https://images.unsplash.com/photo-1501504905252-473c47e087f8?auto=format&fit=crop&q=80'
}, {
  label: 'Alianzas Clave',
  title: 'Escuela Intercultural de Geografía para la Vida',
  subtitle: 'Educación intercultural en territorio',
  href: '#hito-2',
  image: 'https://cdn.magicpatterns.com/uploads/pThwagyMmDVKd3JvAUjsQs/escuelas1.jpg'
}];
export function MilestonesStrip() {
  return <section id="hitos" className="relative z-30 -mt-24 md:-mt-32 px-4 md:px-8 max-w-[1400px] mx-auto" data-id="element-294" data-mp="37bu0z4lkuz9e">
      <div className="flex overflow-x-auto md:grid md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6 pb-8 snap-x snap-mandatory hide-scrollbar" data-id="element-295" data-mp="2jlg9pgath4fv">
        {MILESTONES.map((milestone, index) => <motion.a key={milestone.title} href={milestone.href} initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-50px'
      }} transition={{
        duration: 0.5,
        delay: index * 0.1
      }} className="group relative block flex-none w-[280px] md:w-auto h-[320px] md:h-[400px] snap-center overflow-hidden bg-forest cursor-pointer focus:outline-none focus-visible:ring-2 focus-visible:ring-clay" data-id="element-296" data-mp="34btxpkw830pz" data-mpi={index}>
            <div className="absolute inset-0 bg-forest/40 group-hover:bg-forest/20 transition-colors duration-500 z-10" data-id="element-297" data-mp="2ze1w1z5s008l" />
            <img src={milestone.image} alt={milestone.title} className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" data-id="element-298" data-mp="9nouhcnvmjrh" />
            <div className="absolute inset-0 z-20 p-6 flex flex-col justify-end bg-gradient-to-t from-forest/90 via-forest/40 to-transparent" data-id="element-299" data-mp="1u5z86pqlrhls">
              <span className="text-clay font-bold tracking-widest text-xs uppercase mb-2 block" data-id="element-300" data-mp="1pdy2xnruqr59">
                {milestone.label}
              </span>
              <h3 className="text-bone font-serif text-xl md:text-2xl leading-tight mb-2" data-id="element-301" data-mp="1geksarrzrwiy">
                {milestone.title}
              </h3>
              <p className="text-bone/80 text-sm font-light leading-snug opacity-0 group-hover:opacity-100 transform translate-y-4 group-hover:translate-y-0 transition-all duration-300" data-id="element-302" data-mp="1beomcmzqhv0r">
                {milestone.subtitle}
              </p>
            </div>
          </motion.a>)}
      </div>
    </section>;
}